import { Dispatch } from '../components/architecture/frontend/index'
import { Auth } from 'aws-amplify'
import { Hub } from 'aws-amplify'
import { from } from 'rxjs';

Hub.listen('auth', (data) => {
  from(Auth.currentAuthenticatedUser())
    .subscribe(e => Dispatch.nextState('user', {state: e?.attributes?.email ? 'signedin' : null, email: e?.attributes?.email ?? undefined}))
})

Dispatch.getAction('signOut')
  .subscribe(e => {
    Auth.signOut()
    Dispatch.nextState('user', {state: null, email: null})
  })